import React from "react"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import Container from "@/common/components/UI/Container"
import Image from "@/common/components/Image"
import Heading from "@/common/components/_UI/Heading"

import Image1 from "@/common/assets/image/joinUs/benefits/salary.svg"
import Image2 from "@/common/assets/image/joinUs/benefits/equipment.svg"
import Image3 from "@/common/assets/image/joinUs/benefits/events.svg"

const BenefitsData = [
  {
    title: "benefit.1.title",
    content: [
      "benefit.1.content1",
      "benefit.1.content2",
      "benefit.1.content3",
      "benefit.1.content4",
      "benefit.1.content5"
    ],
    img: Image1
  },
  {
    title: "benefit.2.title",
    content: [
      "benefit.2.content1",
      "benefit.2.content2",
      "benefit.2.content3",
      "benefit.2.content4",
      "benefit.2.content5"
    ],
    img: Image2
  },
  {
    title: "benefit.3.title",
    content: [
      "benefit.3.content1",
      "benefit.3.content2",
      "benefit.3.content3",
      "benefit.3.content4",
      "benefit.3.content5"
    ],
    img: Image3
  }
]

export default function Benefits() {
  const { t } = useTranslation("joinUs")
  return (
    <Container>
      <Wrapper>
        <Heading as="h3" content="KryptoGO" />
        <Heading
          as="h2"
          className="text-gradient text-glow"
          content={t("benefit.title")}
        />
        <div className="section">
          {BenefitsData.map(({ title, content, img }) => (
            <Card key={title} title={title} content={content} img={img.src} />
          ))}
        </div>
      </Wrapper>
    </Container>
  )
}

interface CardProps {
  title: string
  content: string[]
  img: any
}

const Card = ({ title, content, img }: CardProps) => {
  const { t } = useTranslation("joinUs")
  return (
    <CardWrapper>
      <div className="imgWrapper ">
        <Image src={img} alt={t(title)} layout="fill" objectFit="contain" />
      </div>
      <h3>{t(title)}</h3>
      <div className="textWrapper">
        {content.map(e => (
          <p key={e}>{t(e)}</p>
        ))}
      </div>
    </CardWrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    text-align: center;
  }
  .section {
    margin-top: 52px;
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    max-width: 1200px;
    gap: 30px 10px;
    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  }
`

const CardWrapper = styled.div`
  position: relative;
  /* width: 400px; */
  /* width: 33%; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 30px;
  .imgWrapper {
    background-color: rgba(0, 0, 0, 0);
    position: relative;
    max-width: 80px;
    max-height: 80px;
    width: 100%;
  }
  .textWrapper {
    flex: 1;
  }
  p {
    margin-top: 2px;
    line-height: 1.3;
    text-align: center;
  }
  h3 {
    margin: 5px 0 10px 0;
    text-align: center;
  }
  @media (max-width: 1000px) {
    border: 1px solid ${themeGet("colors.primary")};
    display: flex;
    width: 100%;
    gap: 10px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding: 30px;
    padding-top: 10px;
    .imgWrapper {
      width: 200px;
      height: 200px;
      display: flex;
    }
    .textWrapper {
      flex: 1 1 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
`
